var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { FilterItem } from "@riseart/filter";
import { FormSelect, FormSelectOption } from "@riseart/form";
import { gridSortSelectCls } from "./Select.less";
function GridSortSelect(_ref) {
  var label = _ref.label, _ref$options = _ref.options, options = _ref$options === void 0 ? [] : _ref$options, onChange = _ref.onChange;
  if (!options || !options.length) {
    return null;
  }
  var selectedValue = null;
  options.some(function(_ref2) {
    var selected = _ref2.selected, value = _ref2.value;
    if (selected) {
      selectedValue = value;
    }
    return selected;
  });
  return /* @__PURE__ */ React.createElement(FilterItem, {
    title: label
  }, /* @__PURE__ */ React.createElement(FormSelect, {
    size: "large",
    className: gridSortSelectCls,
    onChange,
    value: selectedValue,
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer() {
      return document.getElementsByClassName(gridSortSelectCls)[0];
    }, "getPopupContainer")
  }, options.map(function(item) {
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: item.value,
      value: item.value
    }, item.label);
  })));
}
__name(GridSortSelect, "GridSortSelect");
export {
  GridSortSelect
};
